// extracted by mini-css-extract-plugin
export default {"agentTransfer":"agentTransfer_agentTransfer__-fqgb"};